import { render, staticRenderFns } from "./WeixiuPop.vue?vue&type=template&id=4b1be822&scoped=true&"
import script from "./WeixiuPop.vue?vue&type=script&lang=js&"
export * from "./WeixiuPop.vue?vue&type=script&lang=js&"
import style0 from "./WeixiuPop.vue?vue&type=style&index=0&id=4b1be822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1be822",
  null
  
)

export default component.exports